export const CURRENCIES = [
  {
    code: 'EUR',
    symbol: '€',
    label: 'Euros'
  },
  {
    code: 'GBP',
    symbol: '£',
    label: 'Pounds Sterling'
  },
  {
    code: 'USD',
    symbol: '$',
    label: 'Dollars'
  }
];

export const ERROR_CONSTANTS = {
  SEATS_UNAVAILABLE: 'SEATS_UNAVAILABLE'
};

export const MODES = {
  FIXED_PACKAGE: 'FIXED_PACKAGE',
  FIXED_PACKAGE_PERFORMANCE: 'FIXED_PACKAGE_PERFORMANCE',
  FLEX_PACKAGE_PERFORMANCE: 'FLEX_PACKAGE_PERFORMANCE',
  PERFORMANCE: 'PERFORMANCE'
};

/**
 * Using constants allows us to throw an
 * error if an unavailable action is used.
 *
 * The number of actions should be kept to
 * a minimum, instead prefer passing
 * state down through React components.
 *
 * The actions are here primarily so allow
 * communication accross the app between
 * non-React components (e.g. the seat-map DOM)
 * and React components.
 */
export const ACTION_CONSTANTS = {
  SEAT_SELECTED: 'SEAT_SELECTED',
  SEAT_ADDED: 'SEAT_ADDED',
  SEAT_DESELECTED: 'SEAT_DESELECTED',
  SEAT_TOGGLE_SELECTED: 'SEAT_TOGGLE_SELECTED',

  SECTION_SELECTED: 'SECTION_SELECTED',
  SECTION_HOVERED: 'SECTION_HOVERED',
  PRICE_SECTION_SELECTED: 'PRICE_SECTION_SELECTED',
  PRICE_SECTION_HOVERED: 'PRICE_SECTION_HOVERED',

  LEVEL_SELECTED: 'LEVEL_SELECTED',
  LEVEL_PRESELECTED: 'LEVEL_PRESELECTED',
  SCREEN_FILTER_SELECTED: 'SCREEN_FILTER_SELECTED',
  PRICE_FILTER_SELECTED: 'PRICE_FILTER_SELECTED'
};

export const CONTEXT = {
  SECTION_SELECTION: 'SECTION_SELECTION',
  SEAT_SELECTION: 'SEAT_SELECTION'
};

export const CONFIRM_BUTTON_STATES = {
  CONFIRM: 'CONFIRM',
  CONFIRMING: 'CONFIRMING'
};

export const CLASS_NAMES = {
  base: 'seat',
  selected: 'seat--selected',
  hidden: 'seat--hidden',
  killed: 'seat--killed',
  available: 'seat--available',
  unavailable: 'seat--unavailable'
};



// WEBPACK FOOTER //
// ./src/javascripts/constants.js